import { render } from "./RenovationNavLink.vue?vue&type=template&id=364ed934&scoped=true"
import script from "./RenovationNavLink.vue?vue&type=script&lang=js"
export * from "./RenovationNavLink.vue?vue&type=script&lang=js"

import "./RenovationNavLink.vue?vue&type=style&index=0&id=364ed934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364ed934"]])

export default __exports__